const dataStatus = [
    { label: "Terbuka", value: "open", remark: "open" },
    { label: "Proses", value: "inprocess", remark: "inprocess" },
    { label: "Tutup", value: "close", remark: "close" },
]

const MENU_REPORT = {
    dataStatus,
}

export default MENU_REPORT;